"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getPickupOrderDataApi = exports.requestPickupVerificationApi = exports.findOrderByQRCodeApi = exports.findOrderByPickupCodeApi = void 0;
const apiPath_1 = require("../apiPath");
const findOrderByPickupCodeApi = async (axio, pickupCode) => {
    try {
        const data = await axio.get(apiPath_1.API_PATH.pickup.findOrderByPickupCode(pickupCode).frontend);
        return data.data;
    }
    catch (error) {
        throw error.response?.data || error.message;
    }
};
exports.findOrderByPickupCodeApi = findOrderByPickupCodeApi;
const findOrderByQRCodeApi = async (axio, qrCodeValue) => {
    try {
        const data = await axio.get(apiPath_1.API_PATH.pickup.findOrderByQRCode(qrCodeValue).frontend);
        return data.data;
    }
    catch (error) {
        throw error.response?.data || error.message;
    }
};
exports.findOrderByQRCodeApi = findOrderByQRCodeApi;
const requestPickupVerificationApi = async (axio, verificationData) => {
    try {
        const data = await axio.post(apiPath_1.API_PATH.pickup.requestPickupVerification.frontend, verificationData);
        return data.data;
    }
    catch (error) {
        throw error.response?.data || error.message;
    }
};
exports.requestPickupVerificationApi = requestPickupVerificationApi;
const getPickupOrderDataApi = async (axio, orderNumber) => {
    try {
        const data = await axio.get(apiPath_1.API_PATH.pickup.getPickupOrderData(orderNumber).frontend);
        return data.data;
    }
    catch (error) {
        throw error.response?.data || error.message;
    }
};
exports.getPickupOrderDataApi = getPickupOrderDataApi;
//# sourceMappingURL=pickup.js.map